module.exports = __webpack_public_path__ + "static/img/CHICAGO_MAPLE.cd0af4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CHICAGO_MAPLE.jpg
// module id = +Vuy
// module chunks = 0